"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
var spinner = require("../../assets/images/icons/spinner.svg");
var spinnerLarge = require("../../assets/images/icons/spinnerLarge.svg"); // Component
var Spinner = function Spinner(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? _theme_1.palette.snow : _ref$color, _ref$hidden = _ref.hidden, hidden = _ref$hidden === void 0 ? false : _ref$hidden, _ref$mask = _ref.mask, mask = _ref$mask === void 0 ? undefined : _ref$mask;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, Object.assign({
        className: hidden ? 'hidden' : ''
    }, {
        mask: mask
    }), /*#__PURE__*/ react_1.default.createElement(AnimatedSpinner, {
        color: color
    }));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "Spinner__Wrapper",
    componentId: "sc-1fbn6rv-0"
})(["z-index:2;position:absolute;display:flex;align-items:center;justify-content:center;margin:auto;", " opacity:1;transform:scale3d(1,1,1);will-change:opacity,transform;transition:transform 0.6s 0.15s ease-in-out,opacity 0.6s 0.15s ease-in-out;@media only screen and (min-width:", " ){", "}&.hidden{opacity:0;transform:scale3d(0.8,0.8,0.8);}"], function (props) {
    return props.mask ? "\n    top: -10px;\n    bottom: -10px;\n    left: -10px;\n    right: -10px;\n    backdrop-filter: blur(2px);\n    background-color: " + _utils_1.rgba(props.mask, 0.25) + ";\n  " : "\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 24px;\n    height: 24px;\n  ";
}, _theme_1.breakpoint.laptop, function (props) {
    return !props.mask && "\n      width: 32px;\n      height: 32px;\n    ";
});
var AnimatedSpinner = styled_components_1.default.div.withConfig({
    displayName: "Spinner__AnimatedSpinner",
    componentId: "sc-1fbn6rv-1"
})(["background-color:", ";mask-image:url(", ");mask-repeat:no-repeat;mask-position:center;mask-size:contain;width:24px;height:24px;backface-visibility:hidden;will-change:transform;animation:spin 0.6s linear infinite;@keyframes spin{0%{transform:rotateZ(0deg);}100%{transform:rotateZ(360deg);}}@media only screen and (min-width:", " ){mask-image:url(", ");width:32px;height:32px;}"], function (props) {
    return props.color;
}, spinner, _theme_1.breakpoint.laptop, spinnerLarge);
exports.default = Spinner;
